<template>
    <section>
        <h1 class="section-title">{{ $t('identityProvider:error:title') }}</h1>
        <div class="alert alert-danger fade show" role="alert">
            <i class="material-icons">warning</i>
            <span>{{ $t('identityProvider:error:instructions', null, [ $t('identityProvider:tenant:supportName'), $t('identityProvider:tenant:customerServicePhoneNumber') ]) }}</span>
        </div>
    </section>
</template>

<styles>
</styles>

<script>
  export default {
    data: () => ({
      model: {
      },
      disabled: false
    }),

    async mounted () {
    }
  };
</script>